import includes from 'lodash/includes'
import map from 'lodash/map'
import React, { useContext } from 'react'

import { SliderContext } from '@Components/Product/Slider/Context/SliderContext'
import { CircleDotItem, CircleDotWrapper } from '@Components/Product/Slider/styledElements'

const getFirstVisibleSlide = (
  currentSlide: number,
  maxDotsToShow: number,
  numSlides: number,
  offset: number,
) => {
  // in the very beginning of the slides
  if (currentSlide <= offset) {
    return 0
  }
  // at the very end. the last dot *is* the last slide
  if (numSlides - 1 - currentSlide <= offset) {
    return numSlides - maxDotsToShow
  }

  // in the middle
  return currentSlide - offset
}

const maxDotsToShow = 5

const CircleDots = () => {
  const {
    activeSlide,
    setActiveSlide,
    slides,
  } = useContext(SliderContext)

  const numDots = slides.length > maxDotsToShow ? maxDotsToShow : slides.length
  // if currentSlide is the middle dot, offset is the number of dots to the left/right of it
  const offset = Math.floor(numDots / 2)

  const lastVisibleDot = activeSlide.key <= offset ? maxDotsToShow - 1 : activeSlide.key + offset
  const firstVisibleDot = getFirstVisibleSlide(
    activeSlide.key,
    maxDotsToShow,
    slides.length,
    offset,
  )

  const spaceToMove = slides.length <= maxDotsToShow ? 0 : -16 * firstVisibleDot

  return (
    <CircleDotWrapper
      aria-hidden
      maxDotsToShow={maxDotsToShow}
      style={{
        transform: `translateX(${spaceToMove}px)`,
      }}
    >
      {map(slides, (slide, key) => (
        // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
        <CircleDotItem
          key={`${slide.url}-${key}`}
          containsVideo={includes(slide.tags, 'video')}
          isActive={activeSlide.key === key}
          onClick={() => setActiveSlide({ key, recalculate: true })}
          outOfBounds={key < firstVisibleDot || key > lastVisibleDot}
        />
      ))}
    </CircleDotWrapper>
  )
}

export default CircleDots
